export default __webpack_public_path__ + "static/media/startup-enxuta.0b461e8f.jpg";